import { useState, useEffect, useCallback } from 'react';
import { Move, UserProgress } from '../types';
import { loadProgress, resetProgress as clearStorage, toggleStepCompletion, saveProgress } from '../services/storage';

export function useProgress() {
  const [progress, setProgress] = useState<UserProgress>(loadProgress);

  useEffect(() => {
    setProgress(loadProgress());
  }, []);

  const toggleStep = useCallback((stepId: string, move: Move) => {
    let result: { nowCompleted: boolean; moveJustMastered: boolean } = {
      nowCompleted: false,
      moveJustMastered: false,
    };

    setProgress(prev => {
      const res = toggleStepCompletion(prev, stepId, move);
      result = {
        nowCompleted: res.nowCompleted,
        moveJustMastered: res.moveJustMastered,
      };
      return res.updatedProgress;
    });

    return result;
  }, []);

  const setActiveFriend = useCallback((friendId: string) => {
    setProgress(prev => {
      const updated = { ...prev, activeFriendId: friendId };
      saveProgress(updated);
      return updated;
    });
  }, []);

  const resetAll = useCallback(() => {
    const cleared = clearStorage();
    setProgress(cleared);
  }, []);

  return {
    progress,
    toggleStep,
    setActiveFriend,
    resetAll,
  };
}
